import { ReportsService } from 'src/app/services/report/reports.service';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-reports-form',
    templateUrl: './reports-form.component.html',
    styleUrls: ['./reports-form.component.scss'],
})
export class ReportsFormComponent implements OnInit {
    @Input() organisationTag: string; //get current organisation from parent

    reportForm: FormGroup; //handles the data display to the frontend

    reportData = []; //modified data ready for frontend display

    constructor(private reportsService: ReportsService, private formbuilder: FormBuilder) {}

    ngOnInit(): void {
        this.initForm();
    }

    initForm(): void {
        this.reportForm = this.formbuilder.group({
            // on set les formcontrols à null pour les initialiser avec des valeurs nulles
            startDate: new FormControl(null),
            endDate: new FormControl(null),
        });

        // Écoute les changements de formulaire pour appeler getData() avec valueChanges
        this.reportForm.valueChanges.subscribe(() => {
            this.getData();
        });
    }

    /**
     * get the month and year value from the form, check if data is null, gets the date in the right format for bd,
     * call service for bd call and gives assigns the responce to the data array before calling a update of the totals table
     */
    getData(): void {
        let startDate = new DatePipe('en').transform(this.reportForm.controls.startDate.value, 'YYYY-MM-dd');
        let endDate = new DatePipe('en').transform(this.reportForm.controls.endDate.value, 'YYYY-MM-dd');
        // if startDate ou endDate = null, on fait rien
        if (!startDate || !endDate) {
            return;
        }
        //this.formatSelectedDate(day, month, year);
        this.reportsService.getMonthReceiptsFromOrganisation(this.organisationTag, startDate, endDate).subscribe((response) => {
            this.reportData = response;
        });
    }

    /**
     * from the CSV received from service, create an html element before pushing it to be downloaded by the user.
     * @returns
     */
    getCSV() {
        if (this.reportData.length === 0) {
            return;
        }

        let startDate = new DatePipe('en').transform(this.reportForm.controls.startDate.value, 'YYYY-MM-dd');
        let endDate = new DatePipe('en').transform(this.reportForm.controls.endDate.value, 'YYYY-MM-dd');
        // if startDate ou endDate = null, on fait rien
        if (!startDate || !endDate) {
            return;
        }
        this.reportsService.getMonthReceiptsFromOrganisationCSV(this.organisationTag, startDate, endDate).subscribe((response) => {
            var downloadElement = document.createElement('a');
            downloadElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(response.toString());
            downloadElement.target = '_blank';
            downloadElement.download = this.organisationTag + '-' + startDate + '.csv';
            downloadElement.click();
        });
    }
}
